import { render, staticRenderFns } from "./LedgerPiCodes.vue?vue&type=template&id=2a135be2"
import script from "./LedgerPiCodes.vue?vue&type=script&lang=js"
export * from "./LedgerPiCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports